function getBoostJq() {
  if (typeof jQ !== 'undefined' && jQ && jQ.ajax) {
    return jQ;
  }
  if (typeof BoostPFS !== 'undefined' && BoostPFS.jQ) {
    return BoostPFS.jQ;
  }
  if (typeof window.jQuery !== 'undefined') {
    return window.jQuery;
  }
  return null;
}

function mapProductJsToExtras(product) {
  if (!product) {
    return null;
  }
  return {
    id: product.id,
    compare_at_price_min: product.compare_at_price_min || product.compare_at_price || 0,
    price_min: product.price_min || product.price || 0,
    price_max: product.price_max || product.price || 0,
    variants: (product.variants || []).map(function(variant) {
      return {
        id: variant.id,
        price: variant.price || 0,
        compare_at_price: variant.compare_at_price || 0
      };
    })
  };
}

function getExtrasProductDataByAjax(data, templateName, callback) {
  var $ = getBoostJq();
  var products = data || [];
  if (!products.length) {
    callback([]);
    return;
  }
  if (!$) {
    callback([]);
    return;
  }

  var collected = [];
  var remaining = products.length;
  var finished = false;

  function complete() {
    if (finished) {
      return;
    }
    remaining -= 1;
    if (remaining <= 0) {
      finished = true;
      callback(collected);
    }
  }

  products.forEach(function(item) {
    if (!item || !item.handle) {
      complete();
      return;
    }
    $.ajax({
      type: 'GET',
      url: '/products/' + item.handle + '.js',
      dataType: 'json',
      timeout: 4000,
      success: function(product) {
        var mapped = mapProductJsToExtras(product);
        if (mapped) {
          collected.push(mapped);
        }
      },
      complete: function() {
        complete();
      }
    });
  });
}

var currency = boostPFSConfig.general.current_currency.toLowerCase();

function getNewPrices(apiData, productsData) {
  var result = Object.assign({}, apiData, { products: (apiData.products || []).slice() });

  (productsData || []).forEach(function(product) {
    var apiProducts = result.products.filter(function(apiProduct) {
      return apiProduct.id === product.id;
    });
    if (apiProducts.length > 0) {
      for (var i = 0; i < apiProducts.length; i++) {
        var apiProduct = apiProducts[i];
        apiProduct.compare_at_price_min = product.compare_at_price_min / 100;
        apiProduct.price_min = product.price_min / 100;
        apiProduct.price_max = product.price_max / 100;

        apiProduct['compare_at_price_min_' + currency] = product.compare_at_price_min / 100;
        apiProduct['price_min_' + currency] = product.price_min / 100;
        apiProduct['price_max_' + currency] = product.price_max / 100;

        (product.variants || []).forEach(function(variant) {
          if (!apiProduct.variants) {
            return;
          }
          var vidx = apiProduct.variants.findIndex(function(v) {
            return v.id === variant.id;
          });
          if (vidx === -1) {
            return;
          }
          apiProduct.variants[vidx].price = variant.price / 100;
          apiProduct.variants[vidx].compare_at_price = variant.compare_at_price / 100;
        });
      }
    }
  });

  return result;
}

function runAfterCallAsync(result, callback) {
  if (typeof callback !== 'function') {
    return;
  }
  if (!result || !result.products || result.products.length === 0) {
    callback(result);
    return;
  }

  var settled = false;
  function finish(productsData) {
    if (settled) {
      return;
    }
    settled = true;
    try {
      callback(getNewPrices(result, productsData || []));
    } catch (e) {
      callback(result);
    }
  }

  setTimeout(function() {
    finish([]);
  }, 2500);

  try {
    getExtrasProductDataByAjax(result.products, 'boost-multiple-currencies', finish);
  } catch (e) {
    finish([]);
  }
}

if (typeof FilterApi !== 'undefined') {
  FilterApi.afterCallAsync = function(result, callbackFilterApi) {
    runAfterCallAsync(result, callbackFilterApi);
  };
}

if (typeof InstantSearchApi !== 'undefined') {
  InstantSearchApi.afterCallAsync = function(result, callbackInstantSearchApi) {
    runAfterCallAsync(result, callbackInstantSearchApi);
  };
}
